var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliderThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 47,
    viewBox: "0 0 34 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_78_487)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_78_487)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_78_487",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 22H11V34H9L16 41L23 34H21V22Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 22H11V34H9L16 41L23 34H21V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 22V20H9V22H11ZM21 22H23V20H21V22ZM11 34V36H13V34H11ZM9 34V32H4.17157L7.58579 35.4142L9 34ZM16 41L14.5858 42.4142L16 43.8284L17.4142 42.4142L16 41ZM23 34L24.4142 35.4142L27.8284 32H23V34ZM21 34H19V36H21V34ZM11 24H21V20H11V24ZM13 34V22H9V34H13ZM11 32H9V36H11V32ZM7.58579 35.4142L14.5858 42.4142L17.4142 39.5858L10.4142 32.5858L7.58579 35.4142ZM17.4142 42.4142L24.4142 35.4142L21.5858 32.5858L14.5858 39.5858L17.4142 42.4142ZM23 32H21V36H23V32ZM19 22V34H23V22H19Z",
    fill: "current",
    mask: "url(#path-1-inside-1_78_487)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 12,
    fill: "white",
    stroke: "current",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7267 18.06L20.78 15L17.7267 11.94L18.6667 11L22.6667 15L18.6667 19L17.7267 18.06Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2733 11.94L11.22 15L14.2733 18.06L13.3333 19L9.33332 15L13.3333 11L14.2733 11.94Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_78_487",
    x: 0,
    y: 0,
    width: 34,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_78_487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_78_487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_78_487",
    x: 6,
    y: 20,
    width: 22,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_78_487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_78_487",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderThumb);
export default __webpack_public_path__ + "static/media/slider_thumb.948c32304ce4c2c472494c65d6dce4c2.svg";
export { ForwardRef as ReactComponent };